import type { AxiosRequestHeaders } from "axios";

function getHost(headers: any) {
  let goibiboHost = process.env["MOCK_HOST"] || headers?.["x-goibibo-host"];
  if (goibiboHost && goibiboHost.includes("goibibo")) {
    goibiboHost = "www.goibibo.com";
  }
  return goibiboHost || headers?.["x-forwarded-host"] || headers?.["host"];
}

export function enhanceRequestHeaders(
  headers?: AxiosRequestHeaders
): AxiosRequestHeaders {
  const {
    cookie = "",
    "mobile-device": mobile_device,
    cmp,
    dvid,
    "device-id": device_id,
    ...restHeaders
  } = headers || {};

  let x_tm_device = mobile_device === "true" ? "mobile" : "desktop";
  let goMmtHost = getHost(headers);

  if (typeof navigator !== "undefined") {
    x_tm_device = /Mobile|Android|BlackBerry/.test(navigator.userAgent)
      ? "mobile"
      : "desktop";
  }

  if (typeof cmp === "string" && cmp != "") {
    return {
      cmp,
      cookie,
      "x-tm-device": x_tm_device,
      "X-Tm-Client": "desktop",
      "device-id": dvid || device_id || "",
      "Content-Type": "application/json",
      ...(headers?.["x-ins-gommt-host"] || goMmtHost
        ? { "x-ins-gommt-host": headers?.["x-ins-gommt-host"] || goMmtHost }
        : {}),
    };
  }

  return {
    cookie,
    "x-tm-device": x_tm_device,
    "X-Tm-Client": "desktop",
    "device-id": dvid || device_id || "",
    "Content-Type": "application/json",
    ...(headers?.["x-ins-gommt-host"] || goMmtHost
      ? { "x-ins-gommt-host": headers?.["x-ins-gommt-host"] || goMmtHost }
      : {}),
  };
}
